// Estado leve do funil entre etapas (triagem -> proposta -> contratação).
export interface FunnelState {
  lead_id?: string
  triagem_id?: string
  proposta_id?: string
  nome?: string
  email?: string
  telefone?: string
  valor_parcela?: number
  data_entrega_prometida?: string
  estimativa?: { min: number; max: number }
  valor_entrada?: number
  origem?: string
  payload?: Record<string, unknown>
}

const KEY = 'pfa_funnel'

export function getFunnel(): FunnelState {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || '{}') as FunnelState
  } catch {
    return {}
  }
}

export function setFunnel(patch: Partial<FunnelState>): FunnelState {
  const next = { ...getFunnel(), ...patch }
  sessionStorage.setItem(KEY, JSON.stringify(next))
  return next
}

export function clearFunnel(): void {
  sessionStorage.removeItem(KEY)
}

// Hidrata o funil a partir de um handoff externo (ex.: calculadora.pfaa.com.br).
// Formato: /triagem#p=<base64url(JSON)> com { n, e, t, o, ctx }. Roda 1× no boot.
export function hydrateFunnelFromUrl(): void {
  try {
    const m = (window.location.hash || '').match(/[#&]p=([^&]+)/)
    if (!m) return
    const b64 = m[1].replace(/-/g, '+').replace(/_/g, '/')
    const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0))
    const data = JSON.parse(new TextDecoder().decode(bytes)) as {
      n?: string
      e?: string
      t?: string
      o?: string
      ctx?: Record<string, unknown>
    }
    setFunnel({
      nome: data.n || undefined,
      email: data.e || undefined,
      telefone: data.t || undefined,
      origem: data.o || undefined,
      payload: data.ctx || undefined,
    })
    // remove o hash pra não deixar PII no histórico/URL
    window.history.replaceState(null, '', window.location.pathname + window.location.search)
  } catch {
    /* handoff inválido — ignora e segue o fluxo normal */
  }
}
